import React, { Component } from "react";

import DenominatorInput from "./DenominatorInput";
import CurrencyItem from "../../type/currency-item";
import { ArrowBackIcon, ArrowForwardIcon, CloseIcon } from "../../utils/components/icons";

class Denominator extends Component {
  firstFocusableRef = React.createRef();
  lastFocusableRef = React.createRef();

  handleKeyDown = (event) => {
    //console.log("Key down in Denominator:", event.key);
    if (event.key === 'Tab') {
      if (document.activeElement === this.firstFocusableRef.current && event.shiftKey) {
        event.preventDefault();
        this.lastFocusableRef.current.focus();
      } else if (document.activeElement === this.lastFocusableRef.current && !event.shiftKey) {
        event.preventDefault();
        this.firstFocusableRef.current.focus();
      }
    }
    if (event.key === 'Escape') {
      this.handleClose();
    }
  }

  constructor(props) {
    super(props);
    this.recalcDenomination = this.recalcDenomination.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    open: false,
    timeout: null,
    current: null,
    price: new CurrencyItem({})
  };

  componentDidMount() {
    const item = this.props.item || {};
    let current;
    let price = CurrencyItem.create({
      kennziffer: item.kennziffer,
      id: "price",
      name: "price",
      symbol: "€",
      iso: item.iso,
      rate: item.rate,
      denomination: [item.minDenomination],
      minDenomination: item.minDenomination
    });
    if (item.selectedDenomination != null && item.selectedDenomination.items.length > 0) {
      current = item.cloneSelectedDenomination();
      this.setState({ current, price });
      this.calculate();
    } else {
      current = { iso: item.iso, items: [] };
      current.items = (item.denomination || []).map(note => ({ note, amount: 0, count: 0, timeout: null }));
      this.setState({ current, price });
    }
    
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hidden && !this.props.hidden) {
      if (this.firstFocusableRef.current) {
        this.firstFocusableRef.current.focus();
      }
    }

    // focus on modal to enable key navigation
    if (!this.props.hidden && !this.state.open && !this.state.timeout) {
      this.setState({
        timeout: setTimeout(() => {
          const denominator = document.querySelector(".ser-denominator button");
          if (denominator) {
            denominator.focus();
            this.setState({ open: true, timeout: null });
          }
        },
          200
        )
      });
    }
    if (
      !this.props.hidden &&
      this.state.current &&
      Array.isArray(this.state.current.items) &&
      this.state.current.items.filter(item => item.amount > 0).length &&
      this.state.price.getAmount() === 0
    ) {
      this.calculate();
    }
  }

  calculate() {
    if (!this.state.current || !Array.isArray(this.state.current.items)) return;
    const price = this.state.price.clone("price").reset();
    this.state.current.items.forEach((item) => {
      price.addAmount(item.amount);
    });
    if (price.getAmount() !== this.state.price.getAmount()) {
      this.setState({ price });
    }
  }

  validateItem(item) {
    item.amount = (isNaN(item.amount) && item.amount === "") ? 0 : parseInt(item.amount);
    item.count = Math.round(item.amount / item.note);
    item.amount = item.note * item.count;
  }

  recalcDenomination(item) {
    if (!this.state.current || !Array.isArray(this.state.current.items)) return;
    let current = {
      ...this.state.current,
      items: this.state.current.items.map(i => ({ ...i }))
    };
    const changedItem = current.items.find(i => i.note === item.note);
    if (changedItem) {
      changedItem.amount = item.amount;
      this.validateItem(changedItem);
      this.setState({ current });
    }
    this.calculate();
  }

  handleAccept() {
    // TODO: do not change props.item, use dispatch
    let current = !this.props.locked ? this.state.current : null;
    // ensure all our amounts are valid
    if (current && Array.isArray(current.items)) {
      let dirty = false;
      current.items.forEach(item => {
        if (item.timeout != null) {
          window.clearTimeout(item.timeout);
          item.timeout = null;
          this.validateItem(item);
          dirty = true;
        } else {
          // just to be sure ...
          item.amount = (item.amount === "") ? 0 : parseInt(item.amount);
        }
      });
      if (dirty) {
        this.calculate();
      }
      if (this.state.price.getAmount() > 0) {
        this.props.item
          .setSelectedDenomination(current)
          .setSelectedIso()
          .showEuro()
          .setAmount(this.state.price.getAmount());
      } else {
        this.props.item.setSelectedDenomination(null);
      }
    }
    if (typeof this.props.onclose === "function") {
      this.props.onclose(current);
    }
    this.setState({ open: !this.props.hidden });
  }

  handleClose() {
    if (typeof this.props.onclose === "function") {
      this.props.onclose();
    }
    this.setState({ open: !this.props.hidden });
  }

  renderItems() {
    if (this.props.hidden || !this.state.current || !Array.isArray(this.state.current.items)) return null;
    return this.state.current.items.map((item) =>
      <DenominatorInput
        key={"note_" + item.note}
        item={item}
        locked={this.props.locked}
        onblur={this.recalcDenomination}
      />
    );
  }

  render() {
    let helpText = !this.props.locked
      ? <div className="ser-modal-subtitle">
        Hier können Sie die benötigten Banknoten nach Ihren Wünschen zusammenstellen.<br />
        <span className="text-bg-warning">BITTE BEACHTEN:</span>
        Geben Sie den gewünschten <strong>Währungsbetrag</strong> je Banknote ein, nicht die Anzahl der Banknoten.
      </div>
      : null;

    return (
      <div className={this.props.hidden ? "ser-hidden" : "ser-modal ser-fadein text-start"} role="dialog" aria-modal="true" aria-labelledby="denominationTitle">
        <div className="ser-denominator col-12 col-md-10 col-lg-8 p-one">
          <button type="button"
            title="Schließen"
            className="btn btn-default ser-close-modal"
            onClick={this.handleClose}
            ref={this.firstFocusableRef}
          >
            <CloseIcon></CloseIcon>
          </button>
          <h2 id="denominationTitle">Stückelung</h2>
          {helpText}
          <div className="ser-note-boxes d-flex flex-wrap">
            {this.renderItems()}
          </div>
          <div className="ser-note-output-text">
            Ihrer aktuelle Auswahl beträgt{" "}
            <span className="text-secondary ps-one pe-one">{this.state.price.toIso()}</span>
            {" "}was einem Gegenwert von{" "}
            <span className="text-primary ps-one pe-one">{this.state.price.toEuro()}</span>
            {" "}entspricht.
          </div>
          <div className="ser-modal-footer">
            <button type="button"
              className="ser-back btn-link justify-content-start"
              onClick={this.handleClose}
            >
              <ArrowBackIcon />
              zurück
            </button>
            <button type="button"
              className={"btn btn-primary ser-note-continue" + (this.props.locked ? " ser-hidden" : "")}
              onClick={this.handleAccept} ref={this.lastFocusableRef}
            >
              Übernehmen
              <ArrowForwardIcon />
            </button>
          </div>
        </div>
      </div>
    );
  }
};
export default Denominator;
